import React from 'react'
import { useAdminSidebarStore } from 'stores/adminSidebarStore'
import { WrapperContent } from './ContentAdminV2.styles'

const ContentAdminV2 = ({ children }: { children: React.ReactNode }) => {
  const { collapsed } = useAdminSidebarStore()
  return <WrapperContent collapsed={collapsed}>{children}</WrapperContent>
}

export default ContentAdminV2
